import { DESTINY_PROTOCOL, DOWNLOAD_URL } from "@/shared/constants/app";
import { UpdateIPCService } from "@/shared/services/UpdateIPCService";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./CheckEmailPage.module.css";

interface LocationState {
  email?: string;
}

export const CheckEmailPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const email = state?.email;

  return (
    <div className={styles.container}>
      <div className={styles.background}>
        <div className={styles.backgroundBlur1} />
        <div className={styles.backgroundBlur2} />
        <div className={styles.backgroundBlur3} />
      </div>

      <div className={styles.content}>
        <div className={styles.card}>
          <div className={styles.header}>
            <div className={styles.icon}>
              <svg
                className={styles.iconSvg}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h2 className={styles.title}>Регистрация успешна!</h2>
            <p className={styles.subtitle}>Проверьте вашу почту</p>
          </div>

          <div className={styles.message}>
            {email ? (
              <>
                <p className={styles.messageText}>
                  Мы отправили письмо с подтверждением на адрес{" "}
                  <span className={styles.messageEmail}>{email}</span>
                </p>
                <p className={`${styles.messageText} ${styles.messageTextMargin}`}>
                  Перейдите по ссылке в письме, чтобы активировать ваш аккаунт.
                </p>
              </>
            ) : (
              <p className={styles.messageText}>
                Мы отправили письмо с подтверждением. Перейдите по ссылке в
                письме, чтобы активировать ваш аккаунт.
              </p>
            )}
          </div>

          <div className={styles.buttons}>
            <button
              type="button"
              onClick={() => navigate("/login")}
              className={`${styles.button} ${styles.buttonPrimary}`}
            >
              Перейти к входу
            </button>
            <button
              type="button"
              onClick={() => navigate("/register")}
              className={`${styles.button} ${styles.buttonSecondary}`}
            >
              Зарегистрировать другого пользователя
            </button>
            {!UpdateIPCService.isAvailable() && (
              <div className={styles.appBlock}>
                <p className={styles.appBlockText}>
                  Откройте приложение Destiny Games для входа
                </p>
                <button
                  type="button"
                  onClick={() => {
                    window.location.href = DESTINY_PROTOCOL;
                  }}
                  className={`${styles.button} ${styles.buttonApp}`}
                >
                  Открыть Destiny Games
                </button>
                <a
                  href={DOWNLOAD_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.downloadLink}
                >
                  Скачать приложение
                </a>
              </div>
            )}
            <button
              type="button"
              onClick={() => navigate("/")}
              className={`${styles.button} ${styles.buttonTertiary}`}
            >
              На главную
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
